/**
 * AI 트래커 산점도 '표시 필터'의 순수 로직.
 *
 * AITrackerContent 에서 추출 — 브라우저·React 없이 유닛 테스트하기 위한 분리이며 동작은 그대로다
 * (aitrackerProjection.js 와 같은 선례).
 */

import { isEngineDefault } from './aitrackerTimelineCache';

// 초기 디폴트 개념(cid Set) — 3축이 baseline 그대로 = 그 시점까지 학습 기록이 한 번도 반영되지 않은 개념.
// src 는 engineData 형태(라이브 또는 재생 프레임을 스왑한 displayEngineData) 무엇이든 받는다.
export function collectDefaultCids(src) {
  const set = new Set();
  const idx = src?.concept_index;
  if (!Array.isArray(idx)) return set;
  const vScale = src.v_scale || 10000;
  const r = src.r_status || [];
  const h = src.h_status || [];
  const s = src.stability || [];
  for (let i = 0; i < idx.length; i += 1) {
    if (isEngineDefault(r[i], h[i], s[i], vScale)) set.add(idx[i]);
  }
  return set;
}

// r/h/st 범위 필터를 bounds 로 되돌려야 하는가.
// - delta·초기값 숨김 토글: 기준 분포가 바뀌므로 리셋(옛 range 가 새로 드러난 점을 곧바로 걸러내는 dead-end 방지)
// - 최초 로드: 첫 분포에 맞춘다
// - 재생 중: 리셋 금지 — 그때의 bounds 는 '그 프레임' 분포라 라이브 범위를 좁게 덮어쓰고, 재생 중엔 범위
//   필터가 우회되어 사용자가 알아채지도 못한다. 호출부는 false 를 받으면 prev 상태를 갱신하지 않으므로
//   종료 시(inPlayback=false) 같은 변경이 그대로 살아 있어 라이브 bounds 로 정확히 1회 재적합된다
//   (stabilityRange 리셋이 이미 쓰는 규칙과 동일).
export function shouldResetRanges({
  inPlayback, prevShowDelta, showDelta, prevHideDefaults, hideDefaults, hasBounds, rawLength,
}) {
  if (inPlayback) return false;
  if (prevShowDelta !== showDelta) return true;
  if (prevHideDefaults !== hideDefaults) return true;
  return !hasBounds && rawLength > 0; // 최초 로드
}
